<template>
  <div class="page-bar">
    <div class="page-bar-main">
      <a-pagination v-model="current" showLessItems :total="total" @change="changePage" />
    </div>
  </div>
</template>
<script>
import { Pagination, Icon } from 'vant'
export default {
  components: {
    Pagination,
    Icon
  },
  props: {
    total: Number
  },
  data() {
    return {
      current: 1
    }
  },
  mounted() {
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page)
    }
  }
}
</script>